import u from "./design-system.es883.js";
function s(r, t, e) {
  var n = new u(e), o = n.getCountryCodesForCallingCode(r);
  return o ? o.filter(function(a) {
    return i(t, a, e);
  }) : [];
}
function i(r, t, e) {
  var n = new u(e);
  return n.selectNumberingPlan(t), n.numberingPlan.possibleLengths().indexOf(r.length) >= 0;
}
export {
  s as default
};
//# sourceMappingURL=design-system.es938.js.map
